module.exports = __webpack_public_path__ + "img/cloud-upload.e855146d.svg";